import { ElNotification } from 'element-plus'
import type { INotification } from '@shared/types/notification'
import { ENotificationType } from '@shared/types/constants/notification-type'

const open = ({
  message,
  title,
  type = ENotificationType.INFO,
  duration = 3000,
  showClose = false,
  customClass,
}: INotification) => {
  const _customClass = type === ENotificationType.ERROR ? 'el-notification_error ' : ''

  return ElNotification({
    message,
    title,
    dangerouslyUseHTMLString: true,
    customClass: _customClass.concat(customClass || ''),
    position: 'bottom-right',
    duration,
    showClose,
  })
}
const closeAll = () => {
  ElNotification.closeAll()
}
export default {
  open,
  closeAll,
}
